const featureSwitches = {
  enableStartCameraSync: 'enableStartCameraSync',
  enableStartCameraSyncProfilePicture: 'enableStartCameraSyncProfilePicture',
  enableFixSignInWithAnotherAccount: 'enableFixSignInWithAnotherAccount',
  enableSendEventCreateAccountFirstStep: 'enableSendEventCreateAccountFirstStep'
};

export default featureSwitches;
